<template>
  <section class="pm-page">
    <div class="pm-box">
      <div class="pm-logo">
        <img loading="lazy" src="@/assets/images/_Rx-Pros-Logo-01.webp" alt="RxPros">
      </div>

      <h1 class="pm-title">Welcome <br>PriorityMeds Patients.</h1>
      <div class="pm-subtitle">Update Your Password to Access Account</div>
      <p class="pm-text">All of your prescriptions and information updated in our system which will cause zero gaps in treatment.</p>
      <p class="pm-text">All we need you to do is enter the email address associated with your PriorityMeds account and we will send you a link to reset your password.</p>

      <form class="pm-form" @submit.prevent="onSubmit">
        <input
          class="pm-input"
          maxlength="256"
          name="email"
          data-name="Email"
          placeholder="Enter your email"
          type="email"
          id="email"
          required=""
          v-model="email"
        >
        <button type="submit" class="pm-button" :disabled="submitted">
          <span v-if="submitted" class="pm-spinner">
            <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
              <circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
              </circle>
            </svg>
          </span>
          <span v-else>Request Reset Email</span>
        </button>

        <div class="pm-login-q">Already Updated Password?</div>
        <div class="pm-login-link">
          <router-link to="/login">Click Here to Login to Account</router-link>
        </div>
      </form>

      <div class="pm-msg pm-msg--success" v-if="success">
        We have emailed you a link to reset your password.
      </div>
      <div class="pm-msg pm-msg--error" v-if="err">
        No user found with that email address.
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PMUsers',
  props: ['baseUrl'],
  data() {
    return {
      email: null,
      submitted: false,
      success: false,
      err: false
    }
  },
  created() {
    const queryEmail = this.$route.query.email;
    if (queryEmail) {
      this.email = queryEmail;
    }
  },
  methods: {
    onSubmit() {
      this.submitted = true;
      this.err = false;
      this.$axios.post(this.baseUrl + '/api/forgot-password', {
        email: this.email.toLowerCase(),
        app_src: 2,
      }).then(response => {
        if (response.data.status == 'success') {
          this.success = true;
          this.submitted = false;
        } else {
          this.submitted = false;
          this.err = true;
        }
      });
    },
  }
}
</script>

<style scoped>
.pm-page {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 48px 14px 120px;
  box-sizing: border-box;
  background-color: var(--white);
}

.pm-box {
  width: 100%;
  max-width: 460px;
}

.pm-logo {
  width: 100%;
  max-width: 200px;
  margin: 0 auto 28px;
}

.pm-logo img {
  display: block;
  width: 100%;
  height: auto;
}

.pm-title {
  font-family: var(--nunito);
  color: var(--primary-black);
  text-align: center;
  font-size: 40px;
  font-weight: 900;
  line-height: 46px;
  margin: 0 0 20px;
}

.pm-subtitle {
  font-family: var(--nunito);
  color: var(--primary-black);
  text-align: center;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 16px;
}

.pm-text {
  font-family: var(--nunito);
  color: var(--light-black-07);
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 20px;
}

.pm-form {
  width: 100%;
}

.pm-input {
  font-family: var(--nunito);
  color: var(--primary-black);
  background-color: var(--white);
  box-sizing: border-box;
  width: 100%;
  height: 56px;
  padding: 8px 16px;
  font-size: 16px;
  border: 1px solid var(--df-grey);
  border-radius: 8px;
}

.pm-input::placeholder {
  color: var(--999-grey);
}

.pm-button {
  font-family: var(--nunito);
  color: var(--white);
  background-color: var(--logo-green);
  border: none;
  border-radius: 12px;
  width: 100%;
  min-height: 60px;
  margin-top: 12px;
  margin-bottom: 24px;
  padding: 16px;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pm-button:hover {
  background-color: var(--logo-blue);
}

.pm-button:disabled {
  cursor: default;
  opacity: 0.7;
}

.pm-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pm-login-q {
  font-family: var(--nunito);
  color: var(--primary-black);
  text-align: center;
  font-size: 16px;
  margin-bottom: 6px;
}

.pm-login-link {
  text-align: center;
}

.pm-login-link a {
  font-family: var(--nunito);
  color: var(--darkbluetext);
  font-size: 16px;
  text-decoration: none;
}

.pm-login-link a:hover {
  text-decoration: underline;
}

.pm-msg {
  font-family: var(--nunito);
  text-align: center;
  font-size: 15px;
  line-height: 20px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: var(--f6-grey);
  border: 1px solid var(--df-grey);
}

.pm-msg--success {
  color: #31c730;
}

.pm-msg--error {
  color: var(--primary-black);
}

@media screen and (max-width: 479px) {
  .pm-title {
    font-size: 30px;
    line-height: 36px;
  }

  .pm-subtitle {
    font-size: 18px;
    line-height: 20px;
  }
}
</style>
